<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment'
    
   export default {
      page: {
         title: "Reorder",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {

         //const datetime = moment().format("YYYY-MM-DD") + "T00:00";
         return {
            title: "Reorder",
            items: [
               {
                  text: "Orders",
                  href: "/orders",
               },
               {
                  text: "Reorder",
                  active: true,
               },        
            ],

            reorder: {
               patient_id: '',
               order_phone: '',
               amount: '',
               prescription_notes: '',
               coupon_code: '',
               pincode: '',
               delivery_type: 1,
               delivery_datetime: '',
               flat: '',
               address: '',
               remarks: '',             
               location: '',
               latitude: '',
               longitude: '',
               private_delivery: 0,
            },

            order: {},

            patients: [],
            patient_visible: false,
            patient_keyword: '',
            patient_id: '',

            delivery_location: '',
            delivery_marker: { position: { lat: '', lng: '' } },
            delivery_center: { lat: '', lng: '' },
            delivery_current_place: '',

            delivery_mapOptions: {
               disableDefaultUI: true,
            },

            errors: {},
            token: '',

            prescriptions_inputs: [
                  {value: null, preview_image: null, image: null}
              ],
            prescriptions_images: [],

            confirm: {},

            express_delivery_charge: '',
            regular_delivery_charge: '',

            //min_datetime: datetime,

            regular_delivery_datetime: '',
            express_delivery_datetime: '',
         };
      },
      mounted() {
    
      },

      created() {
         this.setDeliveryDate();
         this.fetchSettings();
         this.fetchOrder();
         
      },

      methods: {

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         alphaSpacesOnly(event) {
            let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32)) {
                 return;
            } else {
               event.preventDefault();
            }
         },

         getToken() {
         if (localStorage.getItem('sigohealth_admin')) {
            var sigohealth_admin =  JSON.parse(localStorage.getItem('sigohealth_admin'));
            if(sigohealth_admin.token) {
               this.token = sigohealth_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      },
         fetchSettings() {
            let url = "api/admin/settings/index";         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.regular_delivery_charge = responseData.settings[0].regular_delivery_charge;
               this.express_delivery_charge = responseData.settings[0].express_delivery_charge;
                        
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         fetchOrder() {
            let url = "api/admin/pharmacy/order_details?order_id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.order = responseData.details; 
               
               this.delivery_marker.position.lat = parseFloat(this.order.latitude);
               this.delivery_marker.position.lng = parseFloat(this.order.longitude);

               this.delivery_center.lat = parseFloat(this.order.latitude);
               this.delivery_center.lng = parseFloat(this.order.longitude);
                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         setRegularDeliveryDate() {
            var date = new Date();
            date.setDate(date.getDate() + 2);
            this.reorder.delivery_datetime = date.toISOString().split('T')[0];
         },         

         //sets the position of marker when dragged
         deliveryHandleMarkerDrag(e) {
            this.delivery_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         deliveryPanToMarker() {
            this.$refs.deliveryMapRef.panTo(this.delivery_marker.position);
            this.$refs.deliveryMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         deliveryHandleMapClick(e) {
            this.delivery_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         deliverySetPlace(place) {
            this.delivery_current_place = place;
            if(this.delivery_current_place) {
               const marker = {
                  lat: this.delivery_current_place.geometry.location.lat(),
                  lng: this.delivery_current_place.geometry.location.lng(),
               };
               this.delivery_center = marker;
               this.delivery_marker.position = marker;
               this.delivery_location = place.formatted_address;
            }
         },       

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         setDeliveryDate() {
            var today = moment().format('YYYY-MM-DD');
            var tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');
            var now = moment().format('YYYY-MM-DD hh:mm A');
            //var now = moment('2022-11-22 16:00:00').format('YYYY-MM-DD hh:mm A');


            var regular = moment(today + ' ' + '17:00:00').format('YYYY-MM-DD hh:mm A');
            if(moment(now).isBefore(regular)) {
               this.regular_delivery_datetime = today + ' ' + '20:30:00';
            } else {
               this.regular_delivery_datetime = tomorrow + ' ' + '20:30:00';
            }


            var express = moment(today + ' ' + '19:00:00').format('YYYY-MM-DD hh:mm A');
            if(moment(now).isBefore(express)) {
                  this.express_delivery_datetime = moment().add(2,'hours');
            } else {
                  this.express_delivery_datetime = tomorrow + ' ' + '11:00:00';
            }

         },

         confirmOrder() {
            
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/pharmacy/orders/reorder_getvalues";  

       
            let formData = new FormData();
            formData.append("order_id", this.$route.params.id);
            formData.append("patient_id", this.$route.params.pid);
            formData.append("amount", this.reorder.amount); 
            formData.append("coupon_code", this.reorder.coupon_code); 
            formData.append("pincode", this.order.pincode);             
            formData.append("delivery_type", this.order.delivery_type); 
            formData.append("mobile", this.order.order_phone); 
            formData.append("flat", this.order.flat); 
            formData.append("address", this.order.address); 
            formData.append("remarks", this.order.remarks); 
            formData.append("latitude", this.delivery_marker.position.lat); 
            formData.append("longitude", this.delivery_marker.position.lng); 
            formData.append("private_delivery", this.order.private_delivery); 
            formData.append("map_location", this.delivery_location); 

            let delivery_date = '';
            let delivery_time = '';

            if(this.order.delivery_type == 1) {
               this.reorder.delivery_datetime  = this.regular_delivery_datetime;
            } else {
               this.reorder.delivery_datetime  = this.express_delivery_datetime;
            }

            if(this.reorder.delivery_datetime != '') {

               delivery_date  = moment(this.reorder.delivery_datetime).format("YYYY-MM-DD");
               delivery_time = moment(this.reorder.delivery_datetime).format("hh:mm A");
            } 

            formData.append("delivery_date", delivery_date); 
            formData.append("delivery_time", delivery_time); 
        
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.confirm = response.data.data;
                     this.showModal('confirm-modal');
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  
                  console.log(response);
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         createOrder() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/pharmacy/orders/reorder";  

       
            let formData = new FormData();
            formData.append("order_id", this.$route.params.id);
            formData.append("patient_id", this.$route.params.pid);
            formData.append("amount", this.reorder.amount); 
            formData.append("coupon_code", this.reorder.coupon_code); 
            formData.append("pincode", this.order.pincode);             
            formData.append("delivery_type", this.order.delivery_type); 
            formData.append("mobile", this.order.order_phone); 
            formData.append("flat", this.order.flat); 
            formData.append("address", this.order.address); 
            formData.append("remarks", this.order.remarks); 
            formData.append("latitude", this.delivery_marker.position.lat); 
            formData.append("longitude", this.delivery_marker.position.lng); 
            formData.append("private_delivery", this.order.private_delivery); 
            formData.append("map_location", this.delivery_location); 

            let delivery_date = '';
            let delivery_time = '';

            if(this.order.delivery_type == 1) {
               this.reorder.delivery_datetime  = this.regular_delivery_datetime;
            } else {
               this.reorder.delivery_datetime  = this.express_delivery_datetime;
            }

            if(this.reorder.delivery_datetime != '') {

               delivery_date  = moment(this.reorder.delivery_datetime).format("YYYY-MM-DD");
               delivery_time = moment(this.reorder.delivery_datetime).format("hh:mm A");
            } 

            formData.append("delivery_date", delivery_date); 
            formData.append("delivery_time", delivery_time); 
     
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: 'pharmacy.orders'});
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         clearForm() {
            this.errors = {};

            this.reorder.amount = '';
            this.reorder.coupon_code = '';
            this.order.pincode = '';
            this.order.delivery_type = '';
            this.reorder.delivery_datetime = '';
            this.order.address = '';
            this.order.flat = '';
            this.order.order_phone = '';
            this.order.remarks = '';          
            this.order.location = '';
            this.order.latitude = '';
            this.order.longitude = '';
            this.order.private_delivery = '';

            this.delivery_location = '';
         }
      },
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'pharmacy.orders' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  
                  <!-- <b-card header-class="bg-transparent border-light" class="border border-light"> -->
                     <form class="form-horizontal" role="form" @submit.prevent="confirmOrder()">
                        <div class="row">
                           
                        
                           <!-- <div class="form-group col-md-7 col-lg-6">
                              <label>Delivery Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="order.delivery_type" name="delivery_type"> 
                                 <div class="form-check-inline"> 
                                    <b-form-radio value="1" class="mr-5">
                                       Regular Delivery
                                       <p class="small">Rs. {{regular_delivery_charge}} Delivery charge<br>Delivery in 1 to 2 days</p>
                                    </b-form-radio> 
                                 </div>
                                 <div class="form-check-inline">  
                                    <b-form-radio value="2">
                                       Express Delivery
                                       <p class="small">Rs. {{express_delivery_charge}} Delivery charge<br>Same day delivery</p>
                                    </b-form-radio>
                                 </div>
                              </b-form-radio-group>

                              <div v-for="(val, index) in errors.delivery_type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div> -->

                           <div class="form-group col-md-12 col-lg-10">
                              <label>Delivery Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="order.delivery_type" name="delivery_type" @change="setDeliveryDate()"> 
                                 <div class="row"> 
                                    <div class="col-sm-6 col-lg-5">
                                       <b-form-radio value="1" class="mr-5">
                                          Regular Delivery
                                          <p class="small">Rs. {{regular_delivery_charge}} Delivery charge</p>
                                       </b-form-radio> 
                                    </div>
                                    <div class="col-sm-6 col-lg-7">
                                       <p>Get it by <span class="text-bold">{{regular_delivery_datetime | formatDate}}, <br>06:00 PM to 08:30 PM</span></p>
                                    </div>
                                 </div>
                                 <div class="row"> 
                                    <div class="col-sm-6 col-lg-5">
                                       <b-form-radio value="2">
                                          Express Delivery
                                          <p class="small">Rs. {{express_delivery_charge}} Delivery charge</p>
                                       </b-form-radio>
                                    </div>
                                    <div class="col-sm-6 col-lg-7">
                                       <p>Get it by <span class="text-bold">{{express_delivery_datetime | formatDate}}, <br>{{express_delivery_datetime | formatTimeOnly}}</span></p>
                                    </div>
                                 </div>
                              </b-form-radio-group>

                              <div v-for="(val, index) in errors.delivery_type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>    

                           

                          
                        </div>
                        <div class="row">

                           <div class="form-group col-md-6">
                              <label>Mobile <span class="text-danger">*</span></label>
                              <b-input-group size="sm" prepend="+91">
                                 <input type="text" class="form-control" v-model="order.order_phone" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }" @keypress="numbersOnly"/>

                                 <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-input-group>
                           </div>

                           <div class="form-group col-md-6">
                              <label>Pincode <span class="text-danger">*</span> </label>
                              <input type="text" v-model="order.pincode" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.pincode) }" @keypress="numbersOnly"> 

                              <div v-for="(val, index) in errors.pincode" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>

                           <div class="form-group col-md-6">
                              <label>House Name/ Flat No.</label>
                              <input type="text" v-model="order.flat" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.pincode) }"> 

                              <div v-for="(val, index) in errors.flat" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>
                        
                           <div class="form-group col-md-6">
                              <label>Delivery Address <span class="text-danger">*</span> </label>
                              <textarea class="form-control" rows="3" v-model="order.address" v-bind:class="{ 'is-invalid': Boolean(errors.address) }"></textarea>

                              <div v-for="(val, index) in errors.address" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>                         

                           <div class="form-group col-md-12">
                              <label>Remarks </label>
                              <textarea class="form-control" v-model="order.remarks" rows="3" v-bind:class="{ 'is-invalid': Boolean(errors.remarks) }"></textarea>

                              <div v-for="(val, index) in errors.remarks" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>

                           <div class="form-group col-md-6">
                              <label>Amount (in Rs)<span class="text-danger">*</span></label>
                              <input type="number" min="1" max="10000" v-model="reorder.amount" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.amount) }"> 

                              <div v-for="(val, index) in errors.amount" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>    
                           </div>             

                           <div class="form-group col-md-6">
                              <label>Coupon Code </label>
                              <input type="text" v-model="reorder.coupon_code" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.coupon_code) }"> 

                              <div v-for="(val, index) in errors.coupon_code" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>

                           <b-col md="12" class="mb-3">
                              <label class="control-label">Location</label>
                              <GmapAutocomplete @place_changed="deliverySetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here to pick the required latitude and longitude..."  :value="delivery_location"/>
                              <p class="small">Leave this empty if you don't want to change the latitude and longitude</p>
                              
                              <GmapMap v-if="delivery_location"
                                 :center="delivery_center"
                                 :zoom="18"
                                 map-style-id="delivery-roadmap"
                                 :options="delivery_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="deliveryMapRef"
                                 @click="deliveryHandleMapClick">
                                    <GmapMarker
                                       :position="delivery_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="deliveryHandleMarkerDrag"
                                       @click="deliveryPanToMarker"
                                    />
                              </GmapMap>                          
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Latitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="delivery_marker.position.lat" autocomplete="off" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }" type="number" step="any"></b-form-input>

                              <div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                              
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Longitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="delivery_marker.position.lng" autocomplete="off" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }" type="number" step="any"></b-form-input>

                              <div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                              
                           </b-col>

                           <div class="form-group col-md-12">
                              <label class="control-label">Private Delivery</label>
                              <b-form-checkbox                                
                                 v-model="order.private_delivery"
                                 value="1"
                                 unchecked-value="0"
                              >
                              <p class="small ms-2">Items will not be displayed on the package</p>
                           </b-form-checkbox>
                           </div>
                        </div>


                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Save</button>
                              <router-link :to="{ name: 'pharmacy.orders' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  <!-- </b-card> -->
               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <b-modal ref="confirm-modal" id="confirm-modal" title="Confirm Order" hide-footer >
         <b-form @submit.prevent="createOrder()">
            <b-row>  
               <b-col lg="12" class="form-group">
                  <div class="table-responsive">
                     <table class="table table-striped order-summary">
                        <tr>
                           <td class="td-title">Amount</td>
                           <td class="td-content">Rs. {{confirm.price}}</td>
                        </tr>
                        <tr v-if="confirm.discount">
                           <td class="td-title">Discount</td>
                           <td class="td-content">- Rs. {{confirm.discount}}</td>
                        </tr>
                        <tr>
                           <td class="td-title">Delivery Charge</td>
                           <td class="td-content">Rs. {{confirm.delivery_charge}}</td>
                        </tr>
                        <tr>
                           <td class="td-title text-bold">Total</td>
                           <td class="td-content">Rs. {{confirm.total}}</td>
                        </tr>
                     </table>
                  </div>
               </b-col>    
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Confirm</b-button>
                  <b-button class="" variant="light" @click="hideModal('confirm-modal')">Cancel</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
